import GenericLoadingGrid from './GenericLoadingGrid';

export default GenericLoadingGrid;
